import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlmBadgeComponent } from './glm-badge.component';
import { GLMMaterialDesignModule } from '../material-design/material-design.module';



@NgModule({
  declarations: [GlmBadgeComponent],
  imports: [
    CommonModule,
    GLMMaterialDesignModule
  ],
  exports: [GlmBadgeComponent]
})
export class GlmBadgeModule { }
